<div class="create-course">
  <div *ngIf="showSpinner" class="progress-spinner">
    <mat-spinner></mat-spinner>
  </div>
  <mat-card-title class="mat-display-1 mb-5">
    <span>Demokratiewerkstatt anlegen</span>
  </mat-card-title>
  <div class="form">
    <mat-card>
      <mat-card-content *ngIf="demokratiewerkstatt">
        <div class="new-form">
          <form [formGroup]="demokratiewerkstattForm" (ngSubmit)="submitForm()">
            <div class="mb-2">
              <div class="title1">
                <span class="projName">Demokratiewerkstatt Titel</span>
                <div class="subtitle1">
                  <input class="inputTitle" formControlName="title" label="Demokratiewerkstatt Titel"
                         placeholder="Ihr Titel hier"/>
                </div>
              </div>
              <span class="note">Mindestens 4 Zeichen</span>
            </div>
            <div class="mb-2">
              <div class="titleDate">
                <span class="DemokratiewerkstattName">Wann</span>
                <div class="subtitle1">
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate formControlName="start_date" placeholder="Start"
                           style="color: #fff !important"/>
                    <input style="color: #fff !important" matEndDate formControlName="end_date" placeholder="End"
                           style="color: #fff !important"/>
                  </mat-date-range-input>

                  <mat-datepicker-toggle style="color: #fff !important" matIconSuffix
                                         [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </div>
              </div>
              <span class="note">DD/MM/YYYY - DD/MM/YYYY</span>
            </div>
            <div class="mb-2">
              <div class="title1">
                <span class="projName">Wo:</span>
                <div class="subtitle1">
                  <input class="inputTitle" formControlName="location" label="Demokratiewerkstatt Titel"
                         placeholder="Adresse"/>
                </div>
              </div>
            </div>
            <div class="mb-5">
              <ngx-dropzone class="selectImage" (change)="onSelectLogo($event)">
                <ngx-dropzone-label>Demokratiewerkstatt logo ziehen und ablegen</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of logoFile" [removable]="true" (removed)="onRemoveLogo(f)">
                  <ngx-dropzone-label>
                    <img [src]="previewLogoDemokratiewerkstatt" alt="f.name" class="preview-image"/>
                  </ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>
            <div class="mb-5">
              <ngx-dropzone class="selectImage" (change)="onSelectImageProject($event)">
                <ngx-dropzone-label>Demokratiewerkstatt bild ziehen und ablegen</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of imageDemokratiewerkstatt" [removable]="true"
                                      (removed)="onRemoveImageProject(f)">
                  <ngx-dropzone-label>
                    <img [src]="previewDemokratiewerkstattImage" alt="f.name" class="preview-image"/>
                  </ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>
            <div class="mb-5">
              <ngx-dropzone class="selectImage" (change)="onSelectSponsorImage($event)">
                <ngx-dropzone-label>Ziehen und Ablegen von Sponsorenbildern</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of previewSponsorImage" [removable]="true"
                                      (removed)="onRemoveSponsorImage(f)">
                  <ngx-dropzone-label class="sponsor-images">
                    <img [src]="f" alt="f.name" class="preview-image"/>
                  </ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>
            <div class="mb-5">
              <ngx-dropzone class="selectImage" (change)="onSelectParntnerImage($event)">
                <ngx-dropzone-label>Ziehen und Ablegen von Sponsorenbildern</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of previewPartnerImage" [removable]="true"
                                      (removed)="onRemovePartnerImage(f)">
                  <ngx-dropzone-label class="sponsor-images">
                    <img [src]="f" alt="f.name" class="preview-image"/>
                  </ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>
            <div class="form-group bg-dark mb-3 content">
              <label>Beschreibung</label>
              <app-rich-text-editor [control]="contentControl"></app-rich-text-editor>
            </div>
            <mat-card-actions>
              <button mat-raised-button color="primary" [disabled]="demokratiewerkstattForm.invalid">
                Speichern
              </button>
              <button mat-raised-button color="primary" (click)="cancelEdit()">
                Cancel
              </button>
            </mat-card-actions>
          </form>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card *ngIf="demokratiewerkstattPreview$ | async as project" class="preview">
      <h1>Vorschau</h1>
      <mat-card-header>
        <mat-card-title>{{ project.title }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="properties">
          <div *ngIf="project.start_date">
            <p class="label">Wann:</p>
            <p class="value">
              {{ project.start_date | date }} - {{ project.end_date | date }}
            </p>
          </div>
          <div *ngIf="project.location">
            <p class="label">Wo:</p>
            <p class="value">{{ project.location }}</p>
          </div>
          <div *ngIf="previewLogoDemokratiewerkstatt === ''">
            <p class="label">Demokratiewerkstatt logo:</p>
            <p class="value">
              <img [src]="previewLogoDemokratiewerkstatt" alt=""/>
              <i class="fa-regular fa-circle-xmark closeBtn"
                 (click)="removeImage(previewLogoDemokratiewerkstatt, 'icon')"
                 *ngIf="previewLogoDemokratiewerkstatt"></i>
            </p>
          </div>
          <div *ngIf="previewLogoDemokratiewerkstatt !== ''">
            <p class="label">Demokratiewerkstatt logo:</p>
            <p class="value">
              <img [src]="previewLogoDemokratiewerkstatt" alt=""/>
            </p>
          </div>
          <div *ngIf="project.demokratiewerkstatt_image_url && previewDemokratiewerkstattImage === ''">
            <p class="label">Demokratiewerkstatt bild-URL:</p>
            <p class="value">
              <img [src]="previewDemokratiewerkstattImage" alt=""/>
              <i class="fa-regular fa-circle-xmark closeBtn"
                 (click)="removeImage(previewDemokratiewerkstattImage, 'cover')"
                 *ngIf="previewDemokratiewerkstattImage"></i>
            </p>
          </div>
          <div *ngIf="previewDemokratiewerkstattImage !== ''">
            <p class="label">
              Demokratiewerkstatt bild-URL:
            </p>
            <p class="value">
              <img [src]="previewDemokratiewerkstattImage" alt=""/>
            </p>
          </div>
          <div *ngIf="
              project.sponsor_images_url && previewSponsorImage.length === 0
            ">
            <p class="label">Demokratiewerkstatt sponsor Bild-URL:</p>
            <p class="value" *ngFor="let url of project.sponsor_images_url">
              <img [src]="url" alt=""/>
              <i class="fa-regular fa-circle-xmark closeBtnFor"
                 *ngIf="project.sponsor_images_url && project.sponsor_images_url.length > 0"
                 (click)="removeImage(url, 'sponsor')"></i>
            </p>
          </div>
          <div *ngIf="previewSponsorImage.length !== 0">
            <p class="label">Demokratiewerkstatt sponsor Bild-URL:</p>
            <p class="value" *ngFor="let url of previewSponsorImage">
              <img [src]="url" alt=""/>
            </p>
          </div>
          <div>
            <div *ngIf="
                project.partners_images_url && previewPartnerImage.length === 0
              ">
              <p class="label">Demokratiewerkstatt parner Bild-URL:</p>
              <p class="value" *ngFor="let url of project.partners_images_url">
                <img [src]="url" alt=""/>
                <i class="fa-regular fa-circle-xmark closeBtnFor" *ngIf="url" (click)="removeImage(url, 'partner')"></i>
              </p>
            </div>
            <div *ngIf="previewPartnerImage.length !== 0">
              <p class="label">Demokratiewerkstatt partner Bild-URL:</p>
              <p class="value" *ngFor="let url of previewPartnerImage">
                <img [src]="url" alt=""/>
              </p>
            </div>
          </div>
          <div *ngIf="project.director">
            <p class="label">Direktor:</p>
            <p class="value">{{ project.director }}</p>
          </div>
          <div *ngIf="project.code">
            <p class="label">Code:</p>
            <p class="value">{{ project.code }}</p>
          </div>
        </div>
        <div [innerHTML]="project.content" class="preview-content"></div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
